import React from 'react';
export function ButtonMinWidthElement(props) {
    var minWidth = props.minWidth;
    if (!minWidth) {
        return null;
    }
    return (React.createElement("img", { height: "1", style: {
            display: 'block',
            width: minWidth + "!important",
            height: '1px',
            maxWidth: '100%!important',
            maxHeight: '1px',
        }, src: "https://static.wixstatic.com/media/5e9922_0a9111966d7648649336e1f1546c5ec9~mv2.gif", alt: "" }));
}
//# sourceMappingURL=button-min-width-element.js.map